import { Autocomplete } from '@relay-towing/ui';
import {
  usePlacePredictions,
  type Place,
} from '../../hooks/usePlacePredictions';

/**
 * An address box fed by Google Places. `onPlace` hears the place picked
 * from the list, with its point and its parts, and null once the words
 * are typed over, so a stale point is never kept for a new address.
 */
export function AddressInput({
  value,
  onChange,
  onPlace,
  placeholder,
}: {
  value: string;
  onChange: (value: string) => void;
  onPlace: (place: Place | null) => void;
  placeholder: string;
}) {
  const { options, searched, select } = usePlacePredictions(value);
  return (
    <Autocomplete
      value={value}
      onChange={(next) => {
        onChange(next);
        onPlace(null);
      }}
      options={options}
      searched={searched}
      emptyMessage="No matching addresses"
      placeholder={placeholder}
      onSelect={async (option) => {
        const place = await select(option.id);
        if (!place) return;
        onChange(place.address);
        onPlace(place);
      }}
    />
  );
}
